/* eslint-disable @typescript-eslint/naming-convention */

/* eslint-disable no-var */
export var getGlobal = function getGlobal() {
  var win;

  if (typeof window !== 'undefined') {
    win = window; // @ts-ignore
  } else if (typeof global !== 'undefined') {
    // @ts-ignore
    win = global;
  } else if (typeof self !== 'undefined') {
    win = self;
  } else {
    win = {};
  }

  return win;
};